import { optionSchema } from '@/common/schemas/option.schema';
import { z } from 'zod';

export const assignPosSchema = z.object({
  description: z.string().min(1, { message: 'Campo obrigatório' }),
  establishment_branch: optionSchema,
})

export type AssignPosValidationSchema = z.infer<typeof assignPosSchema>